import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InbOrd02Actions, { InbOrd02Types } from '../Stores/InbOrd02/Actions';

const getAppStore = state => state.app;

export function* inbOrd02FetchInbOrd02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InbOrd02Actions.inbOrd02FetchInbOrd02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `inbOrd/indexProcess/INB_ORD_02/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InbOrd02Actions.inbOrd02FetchInbOrd02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd02Actions.inbOrd02FetchInbOrd02Loading(false));
  }
}

export function* inbOrd02CreateInbOrd02({ hdrIds }) {
  try {
    yield put(InbOrd02Actions.inbOrd02CreateInbOrd02Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `inbOrd/createProcess/INB_ORD_02`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd02Actions.inbOrd02CreateInbOrd02Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd02Actions.inbOrd02CreateInbOrd02Loading(false));
  }
}

export function* inbOrd02GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/slsRtnDetail/update/${hdrId}`));
}

export function* inbOrd02NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/slsRtnDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(InbOrd02Types.INB_ORD02_FETCH_INB_ORD02, inbOrd02FetchInbOrd02),
  takeLatest(InbOrd02Types.INB_ORD02_CREATE_INB_ORD02, inbOrd02CreateInbOrd02),
  takeLatest(InbOrd02Types.INB_ORD02_GO_TO_DOCUMENT, inbOrd02GoToDocument),
  takeLatest(InbOrd02Types.INB_ORD02_NEW_DOCUMENT, inbOrd02NewDocument)
];
